export type RegisterTarget = 'engine' | 'document';

/**
 * 字体子集注册状态。
 */
export const FontSubsetStatus = {
    Registered: 'REGISTERED',
    Error: 'ERROR',
} as const;

export type FontSubsetStatus = (typeof FontSubsetStatus)[keyof typeof FontSubsetStatus];

/**
 * 字体子集注册到指定目标后的运行时信息。
 */
export type FontSubset = {
    /**
     * 业务字体 family，子集基于该 family 生成
     */
    fontFamily: string;
    /**
     * 当前子集覆盖的标准化字符
     */
    chars: string;
    /**
     * 子集名称，形式通常是 `${fontFamily}-${hash}`
     * 比如：AlibabaPuHuiTi-Regular-1b733f3fe3df365beb82b1b3a19a44fe
     */
    name: string;
    /**
     * 当前注册目标下的字体子集状态
     */
    status: FontSubsetStatus;
};
